<template>
  <section
    id="admin-customer-list"
    :dir="$functions.currentLangDirection()"
  >
    <b-card
      no-body
      class="customer-list-card"
    >
      <!-- سربرگ کارت: عنوان + تعداد + دکمهٔ افزودن -->
      <div class="customer-list-header">
        <div class="header-title">
          <feather-icon
            icon="UsersIcon"
            size="22"
          />
          <span class="title-text">لیست مشتریان</span>
          <b-badge
            pill
            variant="light-primary"
            class="count-badge"
          >
            {{ desserts.length }}
          </b-badge>
        </div>
        <b-button
          variant="primary"
          class="add-btn"
          @click="showModal"
        >
          <feather-icon
            icon="PlusIcon"
            size="18"
          />
          <span>افزودن مشتری</span>
        </b-button>
      </div>

      <!-- جستجو -->
      <div class="customer-list-search">
        <v-text-field
          v-model="search"
          label="جستجوی نام، خانوادگی یا شماره موبایل"
          prepend-inner-icon="mdi-magnify"
          clearable
          hide-details
          outlined
          dense
        />
      </div>

      <v-data-table
        class="customer-table"
        v-bind="{ dark: isMobile }"
        :headers="headers"
        :items="desserts"
        :search="search"
        :loading="loading"
        loading-text="در حال بارگذاری…"
        no-data-text="مشتری‌ای یافت نشد"
        no-results-text="نتیجه‌ای برای جستجو پیدا نشد"
        mobile-breakpoint="0"
        :items-per-page="25"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100, -1],
          'items-per-page-text': 'تعداد در صفحه',
          'items-per-page-all-text': 'همه',
          'page-text': '{0}–{1} از {2}',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <div class="row-actions">
            <b-button
              size="sm"
              variant="primary"
              class="action-btn"
              @click="onEditItem(item)"
            >
              <feather-icon icon="Edit2Icon" size="15" />
              <span>ویرایش</span>
            </b-button>
            <b-button
              size="sm"
              variant="success"
              class="action-btn"
              title="ورود به حساب این مشتری (با ثبت در لاگ)"
              @click="onImpersonate(item)"
            >
              <feather-icon icon="LogInIcon" size="15" />
              <span>ورود به حساب</span>
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              class="action-btn"
              @click="onDeleteItem(item)"
            >
              <feather-icon icon="Trash2Icon" size="15" />
              <span>حذف</span>
            </b-button>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="empty-state">
            <feather-icon
              icon="InboxIcon"
              size="36"
            />
            <p class="mt-1 mb-1">
              هنوز مشتری‌ای ثبت نشده است
            </p>
            <b-button
              size="sm"
              variant="outline-primary"
              @click="initialize"
            >
              بارگذاری دوباره
            </b-button>
          </div>
        </template>
      </v-data-table>

      <!-- modal افزودن مشتری -->
      <b-modal
        id="modal-addCustomer"
        ref="modal-addCustomer"
        cancel-variant="outline-secondary"
        :ok-title="$t('Add')"
        :cancel-title="$t('Close')"
        centered
        title="مشتری جدید"
      >
        <b-form>
          <b-form-group
            label="شماره موبایل"
            label-for="v-mobile"
          >
            <b-form-input
              id="v-mobile"
              v-model="customer.mobile"
              class="numeric-input"
              maxlength="11"
              placeholder="09xxxxxxxxx"
              required
            />
          </b-form-group>
          <b-form-group
            label="نام"
            label-for="v-name"
          >
            <b-form-input
              id="v-name"
              v-model="customer.name"
              required
            />
          </b-form-group>
          <b-form-group
            label="نام خانوادگی"
            label-for="v-family"
          >
            <b-form-input
              id="v-family"
              v-model="customer.family"
              required
            />
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="$bvModal.hide('modal-addCustomer')"
          >
            انصراف
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            @click="modalAddCustomer()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- مدال ورود به حساب مشتری -->
      <b-modal
        id="modal-impersonate"
        ref="modal-impersonate"
        centered
        hide-footer
        title="ورود به حساب مشتری"
      >
        <div v-if="impersonateTarget">
          <p>
            شما در حال ورود به حساب
            <b>{{ impersonateTarget.name }} {{ impersonateTarget.family }}</b>
            هستید.
          </p>
          <b-form-group label="دلیل ورود (حداقل ۵ حرف) — در لاگ ثبت می‌شود">
            <b-form-textarea
              v-model="impersonateReason"
              placeholder="مثلاً: پیگیری تیکت پشتیبانی #۱۲۳۴"
              rows="3"
            />
          </b-form-group>
          <div class="impersonate-note">
            <feather-icon
              icon="AlertTriangleIcon"
              size="15"
            />
            یک بنر بالای صفحه نشان می‌دهد با حساب ادمین وارد شده‌اید و همهٔ کارها ثبت می‌شود. با «بازگشت» به حساب خودتان برمی‌گردید.
          </div>
          <div class="d-flex mt-1" style="gap:8px;">
            <b-button
              variant="primary"
              @click="confirmImpersonate"
            >
              ورود به حساب
            </b-button>
            <b-button
              variant="outline-secondary"
              @click="$bvModal.hide('modal-impersonate')"
            >
              انصراف
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-card>
  </section>
</template>
<script>
import {
  BCard, BCardBody, BButton, BFormGroup, BFormInput, BForm, BInputGroup, BBadge, BFormTextarea,
} from 'bootstrap-vue'

// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Vue from 'vue'
import router from '@/router'
import customerService from '@/services/customer.service'
import Customer from '@/models/customer'

export default {
  components: {
    BFormGroup,
    BCard,
    BCardBody,
    BButton,
    BFormInput,
    BForm,
    BInputGroup,
    BBadge,
    BFormTextarea,
  },
  data() {
    return {
      search: '',
      customer: new Customer('', '', '', '', '', ''),
      desserts: [],
      loading: true,
      isMobile: Vue.prototype.$functions.isMobile(),
      impersonateTarget: null,
      impersonateReason: '',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'نام خانوادگی', value: 'family', sortable: true },
        { text: 'شماره موبایل', value: 'mobile', sortable: true },
        { text: 'تاریخ ایجاد', value: 'creationDate', sortable: true },
        {
          text: 'عملیات', value: 'actions', sortable: false, align: 'center',
        },
      ]
    },
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  methods: {
    initialize() {
      this.loading = true
      customerService.getAll({ _id: this.selected, type: 0 }).then(
        res => {
          if (res.status === 'success') {
            this.desserts = []
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
          this.loading = false
        },
        error => {
          this.loading = false
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/admin/user/add' })
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        customerService.delete({
          // eslint-disable-next-line no-underscore-dangle
          userId: this.desserts[index]._id,
          companyId: localStorage.getItem('companySelected'),
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'خطا',
                  text: res.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'خطا',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
    },
    onImpersonate(item) {
      const current = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('user_first'))
      if (current && current.impersonation) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا', text: 'ابتدا از حساب مشتری فعلی برگردید', icon: 'XIcon', variant: 'danger',
          },
        })
        return
      }
      this.impersonateTarget = item
      this.impersonateReason = ''
      this.$refs['modal-impersonate'].show()
    },
    async confirmImpersonate() {
      const item = this.impersonateTarget
      const reason = (this.impersonateReason || '').trim()
      if (!item || reason.length < 5) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا', text: 'دلیلِ ورود حداقل ۵ حرف لازم است', icon: 'XIcon', variant: 'warning',
          },
        })
        return
      }
      const current = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('user_first'))
      try {
        // eslint-disable-next-line no-underscore-dangle
        const res = await customerService.impersonate({ customerId: item._id, reason })
        if (res.status !== 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا', text: res.message, icon: 'XIcon', variant: 'danger',
            },
          })
          return
        }
        // اطلاعات ادمین داخل همین آبجکت کاربر نگه داشته می‌شود تا با «بازگشت» دوباره برگردد
        const adminKey = localStorage.getItem('user') ? 'user' : 'user_first'
        localStorage.setItem('user', JSON.stringify({
          ...res.result.user,
          token: res.result.token,
          isAdmin: false,
          impersonation: { logId: res.result.logId, adminKey, admin: current },
        }))
        localStorage.removeItem('user_first')
        window.location.href = '/'
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا', text: error.message, icon: 'XIcon', variant: 'danger',
          },
        })
      }
    },
    onEditItem(item) {
      this.customer = {}

      const index = this.desserts.indexOf(item)

      // eslint-disable-next-line no-underscore-dangle
      const id = this.desserts[index]._id
      router.push({ name: 'admin-customer-edit', params: { id } })
    },
    modalAddCustomer() {
      // eslint-disable-next-line no-underscore-dangle,radix
      customerService.addUser(this.customer).then(
        res => {
          if (res.status === 'success') {
            this.initialize()
            this.$bvModal.hide('modal-addCustomer')
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'خطا',
                text: res.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    showModal() {
      this.customer = {}
      this.$refs['modal-addCustomer'].show()
    },
  },
}
</script>
<style scoped>
.impersonate-note{background:#fdecec;border:1px solid #f6caca;color:#9a2a2b;border-radius:8px;padding:10px 12px;font-size:12.5px;margin-top:10px;line-height:1.8}

.customer-list-card {
  padding: 0;
  overflow: hidden;
}
.customer-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 1.15rem;
}
.header-title .title-text {
  margin: 0 4px;
}
.count-badge {
  font-size: 0.8rem;
}
.add-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 10px;
}
.customer-list-search {
  padding: 16px 20px 4px;
}
.customer-table {
  padding: 8px 12px 12px;
  background: transparent;
}
.row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
  padding: 4px 0;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 8px;
  padding: 5px 12px !important;
  font-size: 0.78rem;
  white-space: nowrap;
}
.action-btn svg {
  margin: 0;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 0;
  color: #9aa0ac;
}
</style>
<style>
/* ردیف‌ها و هدرِ جدول، سازگار با حالت تیره */
#admin-customer-list .customer-table .v-data-table__wrapper {
  border-radius: 10px;
}
#admin-customer-list .customer-table thead th {
  background-color: #f6f6f9 !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  white-space: nowrap;
}
#admin-customer-list .customer-table tbody tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.015);
}
#admin-customer-list .customer-table tbody tr:hover {
  background-color: rgba(115, 103, 240, 0.06) !important;
}
#admin-customer-list .customer-table tbody td {
  height: 52px !important;
  font-size: 0.9rem;
}
.dark-layout #admin-customer-list .customer-table thead th {
  background-color: #343d55 !important;
}
</style>
